'use strict';
'use es6';
/* These getters are for use while we transition from `PubNubMessageRecord` messages to `CommonMessage` messages.
  They support both PubNubMessageRecord messages and CommonMessage messages.
  If you find yourself debugging something involving these data structures, consider that there may be a mixture of `CommonMessage` and `PubNubMessageRecord`.
  Dont assume that all `common-message-format` operators are compatible with `PubNubMessageRecord` either, since this is an incomplete list.
  */

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getConnectedAccountAddress = exports.getMessageDeleteStatus = exports.getEmailMessageId = exports.getCC = exports.getBCC = exports.getToAddresses = exports.getStatus = exports.getAttachments = exports.getFromAddress = exports.getSubject = exports.getRichText = exports.getPlainText = exports.getTimestamp = exports.getSenderType = exports.getSenderId = exports.getClientTs = exports.getType = exports.getSenderKey = exports.getTopLevelType = exports.getFileIds = exports.getHasMore = exports.getMessageIdForCmf = exports.getStatusTimestamp = exports.getStatusSource = exports.getStatusForCmf = exports.getRichTextForCmf = exports.getPlainTextForCmf = exports.getContentType = undefined;

var _getIn = require('transmute/getIn');

var _getIn2 = _interopRequireDefault(_getIn);

var _pipe = require('transmute/pipe');

var _pipe2 = _interopRequireDefault(_pipe);

var _keyPaths = require('../constants/keyPaths');

var _messageTypes = require('../../pubnub-message/constants/messageTypes');

var _cmfSenderTypes = require('../constants/cmfSenderTypes');

var _isCommonMessageFormat = require('./isCommonMessageFormat');

var _getSenderKeyFromType = require('./getSenderKeyFromType');

var _pubnubMessageGetters = require('../../pubnub-message/operators/pubnubMessageGetters');

var PubNubMessageGetters = _interopRequireWildcard(_pubnubMessageGetters);

var _emailMessageMetadataGetters = require('../../email-message-metadata/operators/emailMessageMetadataGetters');

var EmailMessageMetadataGetters = _interopRequireWildcard(_emailMessageMetadataGetters);

var _getFileAttachments = require('./getFileAttachments');

var _fileAttachmentGetters = require('./fileAttachmentGetters');

var _cmfSenderInterop = require('../../common-message-format-conversion/operators/cmfSenderInterop');

var _emailMetadataGetters = require('./emailMetadataGetters');

var CmfEmailMetadataGetters = _interopRequireWildcard(_emailMetadataGetters);

var _getEmailMessageId = require('../../email-message-metadata/operators/getEmailMessageId');

var _getMessageDeleteStatus = require('../../pubnub-message/operators/getMessageDeleteStatus');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getContentType = exports.getContentType = (0, _getIn2.default)(_keyPaths.CONTENT_TYPE);var getPlainTextForCmf = exports.getPlainTextForCmf = (0, _getIn2.default)(_keyPaths.TEXT);

var getRichTextForCmf = exports.getRichTextForCmf = (0, _getIn2.default)(_keyPaths.RICH_TEXT);

var getStatusForCmf = exports.getStatusForCmf = (0, _getIn2.default)(_keyPaths.MESSAGE_STATUS);

var getStatusSource = exports.getStatusSource = (0, _getIn2.default)(_keyPaths.MESSAGE_STATUS_SOURCE);

var getStatusTimestamp = exports.getStatusTimestamp = (0, _getIn2.default)(_keyPaths.MESSAGE_STATUS_TIMESTAMP);

var getMessageIdForCmf = exports.getMessageIdForCmf = (0, _getIn2.default)(_keyPaths.MESSAGE_ID);

var getHasMore = exports.getHasMore = (0, _getIn2.default)(_keyPaths.HAS_MORE);

var getFileIds = exports.getFileIds = (0, _pipe2.default)(_getFileAttachments.getFileAttachments, _fileAttachmentGetters.getFileIds);

var getTopLevelType = exports.getTopLevelType = (0, _getIn2.default)(_keyPaths.TYPE);

var getTimestampForCMF = (0, _getIn2.default)(_keyPaths.TIMESTAMP);

var getSenderTypeForCMF = (0, _getIn2.default)(_keyPaths.SENDER_TYPE);

var getMessageDeleteStatusForCmf = (0, _getIn2.default)(_keyPaths.MESSAGE_DELETE_STATUS);

var getSenderKey = exports.getSenderKey = function getSenderKey(message) {
  var type = getSenderTypeForCMF(message);
  return (0, _getSenderKeyFromType.getSenderKeyFromType)(type);
};

var getSenderIdForCMF = function getSenderIdForCMF(message) {
  if (getSenderTypeForCMF(message) === _cmfSenderTypes.SYSTEM_SENDER) {
    return null;
  }
  return (0, _getIn2.default)(['sender', getSenderKey(message)], message);
};

var getType = exports.getType = function getType(message) {
  var pubnubMessageType = PubNubMessageGetters.getType(message);
  if (pubnubMessageType) {
    return pubnubMessageType;
  } else {
    return getTopLevelType(message);
  }
};

var getClientTs = exports.getClientTs = function getClientTs(message) {
  if ((0, _isCommonMessageFormat.isCommonMessageFormat)(message)) {
    return getTimestampForCMF(message);
  }
  return PubNubMessageGetters.getClientTs(message);
};

var getSenderId = exports.getSenderId = function getSenderId(message) {
  if ((0, _isCommonMessageFormat.isCommonMessageFormat)(message)) {
    return getSenderIdForCMF(message);
  }
  return PubNubMessageGetters.getSenderId(message);
};

var getSenderType = exports.getSenderType = function getSenderType(message) {
  if ((0, _isCommonMessageFormat.isCommonMessageFormat)(message)) {
    return (0, _cmfSenderInterop.fromCmfSender)(getSenderTypeForCMF(message));
  }
  return PubNubMessageGetters.getSenderType(message);
};

var getTimestamp = exports.getTimestamp = function getTimestamp(message) {
  if ((0, _isCommonMessageFormat.isCommonMessageFormat)(message)) {
    return getTimestampForCMF(message);
  }
  return PubNubMessageGetters.getTimestamp(message);
};

var getPlainText = exports.getPlainText = function getPlainText(message) {
  if ((0, _isCommonMessageFormat.isCommonMessageFormat)(message)) {
    return getPlainTextForCmf(message);
  }
  if (getType(message) === _messageTypes.EMAIL_MESSAGE) {
    return EmailMessageMetadataGetters.getPlainText(message);
  }
  return PubNubMessageGetters.getText(message);
};

var getRichText = exports.getRichText = function getRichText(message) {
  if ((0, _isCommonMessageFormat.isCommonMessageFormat)(message)) {
    return getRichTextForCmf(message);
  }
  if (getType(message) === _messageTypes.EMAIL_MESSAGE) {
    return EmailMessageMetadataGetters.getRichText(message);
  }
  return PubNubMessageGetters.getRichText(message);
};

var getSubject = exports.getSubject = function getSubject(message) {
  if ((0, _isCommonMessageFormat.isCommonMessageFormat)(message)) {
    return CmfEmailMetadataGetters.getSubject(message);
  }
  return EmailMessageMetadataGetters.getSubject(message);
};

var getFromAddress = exports.getFromAddress = function getFromAddress(message) {
  if ((0, _isCommonMessageFormat.isCommonMessageFormat)(message)) {
    return CmfEmailMetadataGetters.getFromAddress(message);
  }
  return EmailMessageMetadataGetters.getFromAddress(message);
};

var getAttachments = exports.getAttachments = function getAttachments(message) {
  if ((0, _isCommonMessageFormat.isCommonMessageFormat)(message)) {
    return getFileIds(message);
  }
  return EmailMessageMetadataGetters.getAttachments(message);
};

var getStatus = exports.getStatus = function getStatus(message) {
  if ((0, _isCommonMessageFormat.isCommonMessageFormat)(message)) {
    return getStatusForCmf(message);
  }
  if (getType(message) === _messageTypes.EMAIL_MESSAGE) {
    return EmailMessageMetadataGetters.getStatus(message);
  }
  return PubNubMessageGetters.getStatus(message);
};

var getToAddresses = exports.getToAddresses = function getToAddresses(message) {
  if ((0, _isCommonMessageFormat.isCommonMessageFormat)(message)) {
    return CmfEmailMetadataGetters.getToAddresses(message);
  }
  return EmailMessageMetadataGetters.getToAddresses(message);
};

var getBCC = exports.getBCC = function getBCC(message) {
  if ((0, _isCommonMessageFormat.isCommonMessageFormat)(message)) {
    return CmfEmailMetadataGetters.getBCC(message);
  }
  return EmailMessageMetadataGetters.getBCC(message);
};

var getCC = exports.getCC = function getCC(message) {
  if ((0, _isCommonMessageFormat.isCommonMessageFormat)(message)) {
    return CmfEmailMetadataGetters.getCC(message);
  }
  return EmailMessageMetadataGetters.getCC(message);
};

var getEmailMessageId = exports.getEmailMessageId = function getEmailMessageId(message) {
  if ((0, _isCommonMessageFormat.isCommonMessageFormat)(message)) {
    return getMessageIdForCmf(message);
  }
  return (0, _getEmailMessageId.getEmailMessageId)(message);
};

var getMessageDeleteStatus = exports.getMessageDeleteStatus = function getMessageDeleteStatus(message) {
  if ((0, _isCommonMessageFormat.isCommonMessageFormat)(message)) {
    return getMessageDeleteStatusForCmf(message);
  }
  return (0, _getMessageDeleteStatus.getMessageDeleteStatus)(message);
};

var getConnectedAccountAddress = exports.getConnectedAccountAddress = function getConnectedAccountAddress(message) {
  if ((0, _isCommonMessageFormat.isCommonMessageFormat)(message)) {
    return CmfEmailMetadataGetters.getConnectedAccountAddress(message);
  }
  return EmailMessageMetadataGetters.getConnectedAccountAddress(message);
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/common-message-format/operators/commonMessageFormatGetters.js
// module id = 13
// module chunks = 2 3